module.exports = "/images/fortum.svg?c2506621e4c31f939b9cdac5b6161814";